import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
// import "./VendorManagement.css";

const Logisticsorderdetails = () => {
    const [activeTab, setActiveTab] = useState("Overview");
    const [data, setData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);

    const currentYear = new Date().getFullYear();
    const years = Array.from(
        { length: Math.max(1, currentYear - 2024 + 1) },
        (_, i) => 2024 + i
    );
    const months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
    ];

    // FIX 1: Initialize all filter states to an empty string ("") to represent "All".
    const [selectedYear, setSelectedYear] = useState("");
    const [selectedMonth, setSelectedMonth] = useState("");
    const [selectedDay, setSelectedDay] = useState("");
    const [days, setDays] = useState([]);

    // Update days based on year and month
    useEffect(() => {
        // This logic is correct, but relies on selectedYear/Month being valid numbers (or strings that can be converted).
        // Our new "" state for "All" will correctly cause this `if` to be false.
        if (selectedYear && selectedMonth !== "") {
            const getDaysInMonth = (year, month) => {
                return new Date(Number(year), Number(month) + 1, 0).getDate();
            };
            const totalDays = getDaysInMonth(selectedYear, selectedMonth);
            const daysArray = Array.from({ length: totalDays }, (_, i) => i + 1);
            setDays(daysArray);
        } else {
            setDays([]);
        }
        setSelectedDay(""); // Reset day when year or month changes
    }, [selectedYear, selectedMonth]);

    // Apply filters
    useEffect(() => {
        // An empty string is "falsy", so this check works perfectly for our new state management.
        let result = data.filter((item) => {
            if (!item.orderDateAndTime) return false; // Skip items with no date

            const itemDate = new Date(item.orderDateAndTime);

            const yearMatch = selectedYear
                ? itemDate.getFullYear() === Number(selectedYear)
                : true;
            const monthMatch =
                selectedMonth !== ""
                    ? itemDate.getMonth() === Number(selectedMonth)
                    : true;
            const dayMatch = selectedDay
                ? itemDate.getDate() === Number(selectedDay)
                : true;

            return yearMatch && monthMatch && dayMatch;
        });

        setFilteredData(result);
    }, [data, selectedYear, selectedMonth, selectedDay]);

    const handleExport = () => {
        if (filteredData.length === 0) {
            alert("There is no data to export.");
            return;
        }
        // The rest of your export logic is fine and will use the correctly filtered data.
        const escapeCsvField = (field) => {
            const str = String(field ?? "");
            if (str.includes(",") || str.includes('"') || str.includes("\n")) {
                return `"${str.replace(/"/g, '""')}"`;
            }
            return str;
        };
        const headers = [
            "S.NO",
            "Order ID",
            "User ID",
            "Date & Time",
            "Category",
            "Type",
            "Name",
            "Payment",
            "Status",
            "Amount",
            "Feedback",
            "Ratings",
        ];
        const csvRows = filteredData.map((item, index) => [
            index + 1,
            item.orderId || "N/A",
            item.userId || "N/A",
            item.orderDateAndTime
                ? new Date(item.orderDateAndTime).toLocaleString()
                : "N/A",
            item.category || item.Category || "N/A",
            item.service || "N/A",
            item.userName || "N/A",
            item.paymentMethod || "N/A",
            item.status || "N/A",
            item.grandTotal !== undefined ? Math.round(item.grandTotal) : "N/A",
            item.Feedback || "N/A",
            item.Ratings || "N/A",
        ]);
        const csvString = [
            headers.map(escapeCsvField).join(","),
            ...csvRows.map((row) => row.map(escapeCsvField).join(",")),
        ].join("\r\n");
        const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.setAttribute("href", url);
        link.setAttribute("download", "orders.csv");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    };

    useEffect(() => {
        fetch(
            "https://backend.maamaas.com/subscription/orders/getallorders/vendor",
            {
                headers: {
                    Authorization:
                        "Bearer eyJhbGciOiJIUzI1NiJ9.eyJyb2xlIjoiVkVORE9SIiwiaWQiOjcsInN1YiI6Ik9idTAwMDciLCJpYXQiOjE3NDk4NzI4NTMsImV4cCI6MTc0OTkwODg1M30.zudXoQORn13KxQshYkf03UZE8ifzayE5WXEP6eupIC4",
                },
            }
        )
            .then((res) => {
                if (!res.ok) {
                    throw new Error(`HTTP error! status: ${res.status}`);
                }
                return res.json();
            })
            .then((fetchedData) => {
                setData(Array.isArray(fetchedData) ? fetchedData : []);
            })
            .catch((error) => {
                console.error("fetching error:", error);
                setData([]);
            });
    }, []);

    const customPurpleBg = {
        backgroundColor: "#b15cd6",
        color: "#fff",
        border: "none",
    };

    const tabContent = {
        Overview: (
            <div style={{ width: "100%", marginTop: "50px" }}>
                <div
                    className="container-fluid py-2 mb-3"
                    style={{ backgroundColor: "#f8f9fa", borderRadius: "6px" }}
                >
                    <div className="row g-2 align-items-center">
                        {/* Year */}
                        <div className="col-6 col-md-3 col-lg-2">
                            <select
                                className="form-select form-select-sm"
                                style={{ ...customPurpleBg, height: "35px" }}
                                value={selectedYear}
                                onChange={(e) => setSelectedYear(e.target.value)}
                            >
                                <option value="">Year</option>
                                {years.map((year) => (
                                    <option key={year} value={year}>
                                        {year}
                                    </option>
                                ))}
                            </select>
                        </div>

                        {/* Month */}
                        <div className="col-6 col-md-3 col-lg-2">
                            <select
                                className="form-select form-select-sm"
                                style={{ ...customPurpleBg, height: "35px" }}
                                value={selectedMonth}
                                onChange={(e) => setSelectedMonth(e.target.value)}
                            >
                                <option value="">Month</option>
                                {months.map((month, index) => (
                                    <option key={index} value={index}>
                                        {month}
                                    </option>
                                ))}
                            </select>
                        </div>

                        {/* Week */}
                        <div className="col-6 col-md-3 col-lg-2">
                            <select
                                className="form-select form-select-sm"
                                style={{ ...customPurpleBg, minWidth: "120px", height: "35px" }}
                            >
                                <option value="weekly">Weekly</option>
                                <option value="sun">Sun</option>
                                <option value="mon">Mon</option>
                                <option value="tue">Tues</option>
                            </select>
                        </div>

                        {/* Day */}
                        <div className="col-6 col-md-3 col-lg-2">
                            <select
                                className="form-select form-select-sm"
                                style={{ ...customPurpleBg, minWidth: "120px", height: "35px" }}
                                value={selectedDay}
                                onChange={(e) => setSelectedDay(e.target.value)}
                                disabled={!selectedYear || selectedMonth === ""}
                            >
                                <option value="">Date</option>
                                {days.map((day) => (
                                    <option key={day} value={day}>
                                        {day.toString().padStart(2, "0")}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div className="col-lg-2"></div>
                        {/* Export Button */}
                        <div className="col-6 col-md-6 col-lg-2 d-flex justify-content-end">
                            <button
                                type="button"
                                className="btn btn-sm fw-bold w-100"
                                style={{
                                    ...customPurpleBg,
                                    height: "35px",
                                    paddingLeft: "15px",
                                    paddingRight: "15px",
                                }}
                                onClick={handleExport}
                            >
                                Export
                            </button>
                        </div>
                    </div>
                </div>

                <div className="table-responsive rr2 ">
                    {/* The table now correctly uses `filteredData` */}
                    <table
                        className="table-striped table-bordered align-middle text-center"
                        style={{ fontSize: "0.9rem", width: "100%" }}
                    >
                        <thead style={{ backgroundColor: "#b15cd6", color: "white" }}>
                            <tr>
                                <th className="p-2 text-nowrap">S.No</th>
                                <th className="p-2 text-nowrap">Order ID</th>
                                <th className="p-2 text-nowrap">User ID</th>
                                <th className="p-2 text-nowrap">Date</th>
                                <th className="p-2 text-nowrap">Time</th>
                                {/* <th className="p-2 text-nowrap">Category</th> */}
                                <th className="p-2 text-nowrap">Vehicle Type</th>
                                <th className="p-2 text-nowrap">Name</th>
                                <th className="p-2 text-nowrap">Payment</th>
                                <th className="p-2 text-nowrap">Status</th>
                                <th className="p-2 text-nowrap">Amount</th>
                                <th className="p-2 text-nowrap">Feedback</th>
                                <th className="p-2 text-nowrap">Ratings</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredData.length > 0 ? (
                                filteredData.map((item, index) => {
                                    let dateStr = "N/A",
                                        timeStr = "N/A";
                                    if (item.orderDateAndTime) {
                                        const dateObj = new Date(item.orderDateAndTime);
                                        dateStr = dateObj.toLocaleDateString();
                                        timeStr = dateObj.toLocaleTimeString([], {
                                            hour: "2-digit",
                                            minute: "2-digit",
                                        });
                                    }
                                    return (
                                        <tr key={item.orderId || index}>
                                            <td className="p-2">{index + 1}</td>
                                            <td className="p-2">{item.orderId || "N/A"}</td>
                                            <td className="p-2">{item.userId || "N/A"}</td>
                                            <td className="p-2">{dateStr}</td>
                                            <td className="p-2">{timeStr}</td>
                                            <td className="p-2">
                                                {item.appType || item.Category || "N/A"}
                                            </td>
                                            <td className="p-2">{item.service || "N/A"}</td>
                                            <td className="p-2">{item.userName || "N/A"}</td>
                                            <td className="p-2">{item.paymentMethod || "N/A"}</td>
                                            <td className="p-2">{item.status || "N/A"}</td>
                                            <td className="p-2">
                                                {item.grandTotal !== undefined
                                                    ? `₹${Math.round(item.grandTotal)}`
                                                    : "N/A"}
                                            </td>
                                            <td className="p-2">{item.feedback || "N/A"}</td>
                                            <td className="text-center p-2">
                                                {[1, 2, 3, 4, 5].map((star) => (
                                                    <span
                                                        key={star}
                                                        style={{
                                                            color:
                                                                item.ratings && Number(item.ratings) >= star
                                                                    ? "#FFD700"
                                                                    : "#e4e5e9",
                                                            fontSize: "18px",
                                                            marginRight: "2px",
                                                        }}
                                                    >
                                                        ★
                                                    </span>
                                                ))}
                                            </td>
                                        </tr>
                                    );
                                })
                            ) : (
                                <tr>
                                    <td colSpan="13" className="text-center fst-italic p-3">
                                        No data available for the selected filters.
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        ),
    };

    return (
        <div className="">
            <div className="row g-0">
                <div
                    className="col-lg-10 pe-0"
                    style={{ height: "100vh", overflowY: "hidden" }}
                >

                    <div
                        style={{
                            overflowY: "auto",
                            height: "calc(100vh - 80px)",
                            marginTop: "-35px",
                        }}
                    >
                        <div className="mt-3">{tabContent[activeTab]}</div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Logisticsorderdetails;
